import React from 'react';
import Carousel from 'react-material-ui-carousel';
import { Box, Typography } from '@mui/material';

import img1 from '../../assets/doppler1.webp'
import img2 from '../../assets/doppler2.webp'
import img3 from '../../assets/doppler3.webp'
import img4 from '../../assets/doppler4.webp'
import img5 from '../../assets/doppler5.webp'


const items = [
    {
        image: img1,
    },
    {
        image: img2,
    },
    {
        image: img3,
    },
    {
        image: img4,
    },
    {
        image: img5,
    },
];

const NuestrasInstalaciones = () => {
    return (
        <Box
            sx={{
                py: 6,
                backgroundColor: '#fffff',
                textAlign: 'center',
                borderRadius: '16px',
            }}
        >
            {/* Título y subtítulo */}
            <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 2, color: 'rgb(41, 54, 54)' }}>
                Galería
            </Typography>
            {/* Carrusel */}
            <Carousel
                animation="slide"
                indicators
                navButtonsAlwaysVisible
                sx={{
                    maxWidth: '800px',
                    margin: '0 auto',
                }}
            >
                {items.map((item, index) => (
                    <Box
                        key={index}
                        sx={{
                            position: 'relative',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            borderRadius: '16px',
                            overflow: 'hidden',
                            backgroundColor: '#fffff',
                            height: '500px', // Altura máxima del contenedor
                        }}
                    >
                        <Box
                            component="img"
                            src={item.image}
                            alt={`Instalación ${index + 1}`}
                            sx={{
                                maxWidth: '100%',
                                maxHeight: '100%',
                                objectFit: 'contain', // Evitar recortes
                                borderRadius: '16px',
                            }}
                        />
                        <Typography
                            variant="body2"
                            sx={{
                                mt: 2,
                                color: '#5a7184',
                                lineHeight: 1.5,
                                fontStyle: 'italic',
                                px: 2,
                            }}
                        >
                            {item.description}
                        </Typography>
                    </Box>
                ))}
            </Carousel>
        </Box>
    );
};

export default NuestrasInstalaciones;
